import React, { Component } from 'react'
import ListadoPage from '../../../containers/page/ListadoPage'
import SimpleModalPage from '../../../containers/comun/modal/SimpleModalPage'
import MensajeAlertaPage from '../../../containers/comun/mensajeAlerta/MensajeAlertaPage'
import FiltrosControlSangrePage from '../../../containers/planSanitario/controlSangre/FiltrosControlSangrePage'
import ModalInicioControlSangrePage from '../../../containers/planSanitario/controlSangre/ModalInicioControlSangrePage'
import ModalControlSangrePage from       '../../../containers/planSanitario/controlSangre/ModalControlSangrePage'

import { date_parser, dateTimeZones } from '../../../util/formatFunctions'
import {permisos as permisosConstant} from '../../../constants/permisos'

class ControlSangre extends Component {
  componentDidMount () {
    document.title = this.props.t('MENU.PLAN_SANITARIO.CONTROL_CALIDAD.CONTROL_SANGRE') + ' - ' + this.props.t('HEADER.TITLE_GESIPOR')
    let fechaActual = date_parser(dateTimeZones(this.props.auth.zonaHorariaString), this.props.auth.formaFechaHora)
    this.props.actions.fetchControlSangre({fechaDesde: fechaActual, 'seleccionar-todo': false})
  }


  imprimirInforme(row){
    if(row.file == null){
        this.props.actions.yesNoModal('fueraLimite', null, null, this.props.t('SIMPLE_MODAL.NO_EXISTE_INFORME'))
    }else{
        this.props.actions.descargarArchivoControlSangre(row)
    }
  }


  render () {
    const {
      mainList = [], checkedFiltros, t, numeroRegistrosPorPagina, paginaActual, showModalControlSangre,
      actions: {deleteControlSangre, recuperarDatosModalControlSangre}
    } = this.props

    

    const tKey = 'PLAN_SANITARIO.CONTROL_SANGRE.'
    const idElemento = 'idControlSangre'
    const idForm = 'controlSangreTable'
    
    const tableControlSangre = {
      id: 'controlSangreTable',
      form: idForm,
      multiHeader: false,
      hasCheckbox: (this.props.auth.permisos === '-1' || this.props.auth.permisos[permisosConstant.CONTROL_SANGRE] > 1),
      idElemento,
      hasOptions: true,
      mostrarModificar: true,
      mostrarDuplicar: false,
      mostrarCambioEstado: false,
      mostrarImprimirInforme: true,
      imprimirInforme: (row) => this.imprimirInforme(row),
      mostrarEliminar: (this.props.auth.permisos === '-1' || this.props.auth.permisos[permisosConstant.CONTROL_SANGRE] > 1),

      onDelete: (row) => deleteControlSangre(row),
      columns: [
        {id: 'idControlSangre', name: t(tKey + 'COLUMNS.CODIGO'), type: 'numero', numDecimales: 0},
        {id: 'nombreVerraco', name: t(tKey + 'COLUMNS.VERRACO')},
        {id: 'vigilado', name: t('FICHA_VERRACO.VIGILADO')},
        {id: 'nombreRaza', name: t(tKey + 'COLUMNS.RAZA')},
        {id: 'nombreLinea', name: t(tKey + 'COLUMNS.LINEA_GENETICA')},
        {id: 'fecha', name: t(tKey + 'COLUMNS.FECHA'), type: 'fecha'},
        {id: 'tipoControl', name: t(tKey + 'COLUMNS.TIPO_CONTROL')},
        {id: 'tipoDirigido', name: t(tKey + 'COLUMNS.TIPO_DIRIGIDO')},
        {id: 'resultado', name: t(tKey + 'COLUMNS.RESULTADO')},
        {id: 'file', name: t(tKey + 'COLUMNS.FICHERO')},
        {id: 'diasUltimoControl', name: t(tKey + 'COLUMNS.DIAS_ULTIMO_CONTROL'), type: 'numero', numDecimales: 0}
      ],
      rows: mainList,
      filtros: <FiltrosControlSangrePage idElemento={idElemento} idForm={idForm} />,
      onEdit: (row) => recuperarDatosModalControlSangre(row.idControlSangre),
      initialValues: {}
    }
    tableControlSangre.rows.forEach(
      (row, idRow) => {
        if (idRow >= numeroRegistrosPorPagina * (paginaActual - 1) && idRow < numeroRegistrosPorPagina * paginaActual) {
          tableControlSangre.initialValues['check' + idForm + row[idElemento]] = checkedFiltros
        }
      }
    )
    return (
      <div>
        <SimpleModalPage/>
        <MensajeAlertaPage/>
        <ModalControlSangrePage/>
        <ModalInicioControlSangrePage showModalControlSangre={showModalControlSangre} />
        <ListadoPage t_key={tKey} table={tableControlSangre}>
        </ListadoPage>
      </div>
    )
  }
}

export default ControlSangre